import { type ReactElement, type ReactNode, useMemo } from 'react';
import { useContextSelection } from '@/shared/hooks/useContextSelection';
import { updateSessionContext, getStoredContext } from '../../../auth/sessionStorage';
import { ProjectFilterContext } from './projectContext';
import type { ProjectFilterContextValue } from './projectTypes';

export const ProjectFilterProvider = ({ children }: { children: ReactNode }): ReactElement => {
  const { value: selectedProjectId, setValue: setSelectedProjectId } = useContextSelection({
    getInitialValue: () => {
      if (typeof window === 'undefined') return null;
      const { lastProjectId } = getStoredContext();
      return lastProjectId;
    },
    onPersist: (value) => {
      updateSessionContext(undefined, value);
    },
  });

  const value = useMemo<ProjectFilterContextValue>(
    () => ({ selectedProjectId, setSelectedProjectId }),
    [selectedProjectId],
  );

  return <ProjectFilterContext.Provider value={value}>{children}</ProjectFilterContext.Provider>;
};
